<template>
    <div class="mainPart widthAuto" v-loading="isLoad"> 
      <p class="commonTit"><b>订单通知配置</b></p>
      <el-form :model="ordForm" :rules="ordRule" label-width="200px" class="mainWrap commonForm" ref="ordForm">
        <el-form-item label="订单通知配置">
          <el-switch v-model="ordForm.bordnotice" :width="45" class="isSwitch" :active-value="1" :inactive-value="0" :active-text="ordForm.bordnotice?'开':'关'"></el-switch>
        </el-form-item>
        <el-form-item label="订单提醒通知时间" prop="stime" v-show="ordForm.bordnotice" class="choseTime allWidth">
          <p class="noticePBox">
            <b>每天</b>
            <el-select v-model="ordForm.stime" clearable placeholder="请选择">
              <el-option v-for="(item,index) in 24" :key="index" :label="index" :value="index" :disabled="(ordForm.etime !== '' && ordForm.etime == index) || (ordForm.stime1 !== '' && ordForm.stime1 == index) || (ordForm.stime2 !== '' && ordForm.stime2 == index)"></el-option>
            </el-select>
            <em>时，和</em>
            <el-select v-model="ordForm.stime1" clearable placeholder="请选择">
              <el-option  v-for="(item,index) in 24"  :key="index"   :label="index"  :value="index" :disabled="(ordForm.etime !== '' && ordForm.etime == index) || (ordForm.stime !== '' && ordForm.stime == index) || (ordForm.stime2 !== '' && ordForm.stime2 == index)"> </el-option>
            </el-select>
            <em>时，和</em>
            <el-select v-model="ordForm.stime2" clearable placeholder="请选择">
              <el-option v-for="(item,index) in 24" :key="index" :label="index" :value="index" :disabled="(ordForm.etime !== '' && ordForm.etime == index) || (ordForm.stime1 !== '' && ordForm.stime1 == index) || (ordForm.stime !== '' && ordForm.stime == index)"></el-option>
            </el-select>
            <em>时，和</em>
            <el-select v-model="ordForm.etime" clearable placeholder="请选择">
              <el-option  v-for="(item,index) in 24"  :key="index"   :label="index"  :value="index" :disabled="(ordForm.stime !== '' && ordForm.stime == index) || (ordForm.stime1 !== '' && ordForm.stime1 == index) || (ordForm.stime2 !== '' && ordForm.stime2 == index)"> </el-option>
            </el-select>
            <em>时</em>
            <span class="tipsMsg iconbulb">温馨提示：请至少设置一个订单通知时间</span>
          </p>  
        </el-form-item>
        <el-form-item label="订阅通知二维码" v-show="ordForm.bordnotice" class="allWidth flexItem">
          <section>
            <div id="ewm" ref="qr_ref" v-loading="loading" element-loading-text="二维码生成中" @mouseover="mouseOver"></div>
            <p class="txtCenter">二维码永久有效</p>
          </section>
          <p class="allLine wxNotice">
            <span class="cursorHand" @click="selGoodsDlog = true">已订阅用户 <em class="redColor fwBold">{{wxuserList}}</em> 人，<b class="mainColor">点击查看<i class="iconright"></i></b></span>
            <span class="iconrefresh mainColor" @click="refreshNum">一键刷新</span>
          </p>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="setOrderNoticeSetting" :loading="isLoad">提交</el-button>
          <el-button @click="getReset">重置</el-button>
        </el-form-item>
      </el-form>

      <!-- S 已订阅微信用户 -->
      <WechatFans :selGoodsDlog="selGoodsDlog" :isGetData="isGetData" @closeChild="selGoodsDlog = false" @userNum="getWXUserNum"></WechatFans>
      <!-- E 已订阅微信用户 -->
    </div>
            

</template>
<script>
import Api from '@/apis/api.js';
import { Message, MessageBox } from "element-ui";
import QRCode from "qrcodejs2";
export default {
  name:'OrdConfiguration',
  data() {
    return {
      ordForm: {
        bordnotice:0,//是否开通订单通知
        stime:'',//订单通时间，以#隔开
        stime1:'',
        stime2:'',
        etime:'',
      },
      ordRule: {
        stime:[
          { required: true, validator: this.changestime, trigger: ['blur','change'] }
        ],
      },
      isLoad:false,
      loading:false,//二维码生成中
      curflowcode:'',
      selGoodsDlog:false,//查看已订阅用户
      QRCodeurl: '', //订阅二维码地址
      isGetData:false,//是否获取过订阅用户
      wxuserList:0,//已订阅人数
    }
  },
  components: {
    WechatFans: resolve => require(["@/components/ManageFolder/WechatFans.vue"], resolve), // 选择微信粉丝
  },
  watch:{
    'ordForm.bordnotice':function(val){
      if(val){
        if(!this.QRCodeurl){
          this.getQRCodeurl();
        }
        if(!this.isGetData){
          this.isGetData = true;
        }
      }
    }
  },
  //   *********************************************************************方法
  methods: { 
    //刷新数据
    refreshNum(){
      this.isGetData = false;
      setTimeout(() => {
        this.isGetData = true;
      }, 20);
    },
    mouseOver() {
      document.getElementById('ewm').title = '';
    },
    //获取订阅二维码
    getQRCodeurl() {
      const protocol = window.location.protocol;
      let domain = window.location.host;
      let base = '/api/center/base';
      if(process.env.NODE_ENV === 'development'){
        base = '/apis/api/center/base';
      }else if(process.env.NODE_ENV === 'production'){
        base = '/api/center/base';
      }
      this.QRCodeurl = `${protocol}//${domain}${base}/pubordprint/nologin/toBind?code=${this.curflowcode}&type=1`
      console.log(this.QRCodeurl,'QRCodeurl');
      this.$nextTick(() => {
        let qrcode1 = new QRCode(this.$refs["qr_ref"], {
          width: 180,
          height: 180, // 高度
          text: this.QRCodeurl, // 二维码内容
          correctLevel: QRCode.CorrectLevel.L
        });
        this.$refs["qr_ref"].title = "";
      });
    },
    //选择时间
    changestime(rule, value, callback){
      if(this.ordForm.bordnotice){
          if(this.ordForm.stime===''&&this.ordForm.stime1===''&&this.ordForm.stime2===''&&this.ordForm.etime===''){
              callback(new Error('请至少设置一个订单通知时间!'));
          }else{
            callback();
          }
      }else{
        callback();
      }
    },
    //订单通知设置
    setOrderNoticeSetting(){
      let params = {}
      // this.$refs['ordForm'].validate((valid) => {
      //   if (valid) {
          //订单通知设置
          params.bordnotice = this.ordForm.bordnotice;
          if(this.ordForm.bordnotice){
            console.log(this.ordForm.stime,this.ordForm.stime1,this.ordForm.stime2,this.ordForm.etime,'gggggggggggg')
            if(this.ordForm.stime===''&&this.ordForm.stime1===''&&this.ordForm.stime2===''&&this.ordForm.etime===''){
              this.$refs.ordForm.validateField('stime', (valid) => {
                if (valid) {
                  this.$message.error('请至少设置一个订单通知时间！');
                  console.log('触发校验');
                } 
              });
              return false
            }else{
              let stimestring = [];
              // params.stime = (this.ordForm.stime!=='' && this.ordForm.etime!=='' && this.ordForm.stime>=0&&this.ordForm.etime>=0) ? this.ordForm.stime+'#'+this.ordForm.etime : (this.ordForm.stime!=='' &&this.ordForm.stime >=0 ?this.ordForm.stime:this.ordForm.etime); 
              if(this.ordForm.stime!=='' && this.ordForm.stime>=0){
                stimestring.push(this.ordForm.stime)
              }
              if(this.ordForm.stime1!=='' && this.ordForm.stime1>=0){
                stimestring.push(this.ordForm.stime1)
              }
              if(this.ordForm.stime2!=='' && this.ordForm.stime2>=0){
                stimestring.push(this.ordForm.stime2)
              }
              if(this.ordForm.etime!=='' && this.ordForm.etime>=0){
                stimestring.push(this.ordForm.etime)
              }
              params.stime = stimestring.join('#');
            }
          }else{
            this.ordForm.stime = '';
            this.ordForm.stime1 = '';
            this.ordForm.stime2 = '';
            this.ordForm.etime = '';
          }
          this.isLoad = true;
          Api.SET_ORDNOTICE(params).then(res =>{
            if(res.data.status == '200'){
              this.$message.success(res.data.message);
              console.log(res.data.data,'success');
              this.viewNewFlowDetail(this.curflowcode);//获取配置详情
            }else{
              this.$message.error(res.data.message);
            }
            this.isLoad = false;
          }).catch(err =>{
            this.isLoad = false;
          })
      //   }else{
      //     this.isLoad = false;
      //     console.log('error submit!!');
      //     return false;
      //   }
      // })
    },
    // 重置
    getReset() {
      this.$refs.ordForm.clearValidate();
      this.ordForm = {
        bordnotice:0,//是否开通订单通知
        stime:'',//订单通时间，以#隔开
        etime:'',//
      }
      this.viewNewFlowDetail(this.curflowcode);//获取配置详情
    },
    //获取已订阅微信用户列表
    getWXUserNum(num){
      this.wxuserList = num;
    },
    //获取流向详情最新的金额信息
    viewNewFlowDetail(flowcode) {
      this.isLoad = true;
      Api.GET_FLOWDETAIL({ flowcode: flowcode }).then(res => {
        if (res.data.status == "200") {  
          let newflowinfo = res.data.data;
          //订单通知
          this.ordForm.bordnotice = newflowinfo.bordnotice;
          if(this.ordForm.bordnotice && newflowinfo.stime){
            if(newflowinfo.stime.includes('#')){
              let stimearr = newflowinfo.stime.split('#');
              this.ordForm.stime = stimearr[0] === undefined ? '' : stimearr[0];
              this.ordForm.stime1 = stimearr[1] === undefined ? '' : stimearr[1];
              this.ordForm.stime2 = stimearr[2] === undefined ? '' : stimearr[2];
              this.ordForm.etime = stimearr[3] === undefined ? '' : stimearr[3];
            }else{
              this.ordForm.stime = newflowinfo.stime;
              this.ordForm.stime1 = '';
              this.ordForm.stime2 = '';
              this.ordForm.etime = '';
            }
          }
          console.log(newflowinfo.bordnotice,newflowinfo.stime,'333')
          this.isLoad = false;
        } else {
          console.log("获取详情信息失败！");
          this.isLoad = false;
        }
      }).catch(err =>{
        this.isLoad = false;
      });
    },
  },
  //   *********************************************************************初始化
  mounted(){
    if (localStorage.getItem('userInfoMd')) {
      let userInfoMd = JSON.parse(localStorage.getItem('userInfoMd'));
      this.curflowcode = userInfoMd.flowcode;
      this.viewNewFlowDetail(this.curflowcode);
    }
  }
}
</script>
<style scoped>
.mainPart .el-form {padding-top:22px;}
.flexItem .wxNotice { margin-left: 10px}
.flexItem .wxNotice span {font-size:14px; cursor: pointer; display:block; line-height:2rem; text-align:center;}
.flexItem>>>.el-form-item__content { display: flex; align-items: center; position: relative;  }
/*订单通知配置 */
.noticePBox {padding-bottom:10px;}
.choseTime>>>.el-form-item__content .el-date-editor{width: 130px!important;}
.choseTime em{margin:0 12px}
.choseTime>>>.el-form-item__content .el-select{width: 100px;}
.tipsMsg {color:#FA2F2F;}
.txtCenter {text-align: center; color:#999; font-size: 12px;}
</style>



// WEBPACK FOOTER //
// src/views/ManageFolder/SysConfiguration/OrdConfiguration/OrdConfiguration.vue